import {Component, Input, OnInit} from '@angular/core';
import * as saveAs from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { SubDataVariables } from '../../../../environments/app.variables';
import { AlertService } from '../../services/alert.service';
import * as Constants from '../../../models/Constants';
import { InspectionService } from '../../../inspection/shared/services/inspection.service';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit {

  @Input() header: any[];
  @Input() tableData: any[];
  @Input() options: any;
  constructor( private spinner: NgxSpinnerService, private alertService: AlertService, private commonService: CommonService) { }

  ngOnInit(): void {
  }

  downloadFile(){
    this.spinner.show();
    this.commonService.getSystemFile(Constants.INSPECTION_CHECKLIST, null).subscribe(resp => {
      this.spinner.hide();
      if(resp){
        const name = 'Inspection Checklist Form.pdf'
        const blob = new Blob([resp], {
          type: 'application/pdf'
        });
        saveAs(blob, name);
        this.alertService.success("Inspection Checklist form downloaded successfully!");
      }else{
        this.alertService.error("Inspection Checklist form could not be downloaded!");
      }
    }, err =>{
      this.spinner.hide();
      console.log(err);
      this.alertService.error("Inspection Checklist form could not be downloaded!");
    })
  }

}
